export const ChatBookingConfig: Record<string, string>[] = [
  {
    key: "firstName",
    displayTitle: "First Name"
  },
  {
    key: "lastName",
    displayTitle: "Last Name"
  },
  {
    key: "email",
    displayTitle: "Email"
  },
  {
    key: "phoneNumber",
    displayTitle: "Phone Number"
  },
  {
    key: "createdAt",
    displayTitle: "Date of Creation"
  },
  {
    key: "lastUpdatedAt",
    displayTitle: "Last Updated Date"
  },
  {
    key: "lastUpdatedBy",
    displayTitle: "Last Updated By"
  },
  {
    key: "status",
    displayTitle: "Status"
  },
  {
    key: "message",
    displayTitle: "Inquiry Message"
  }
];
